import React from 'react';
import { MAIN_MOCKUP } from '../data/content';
import { ViewerCounter } from './ViewerCounter';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
import { GuaranteeSection } from './GuaranteeSection';
import { OfferCountdown } from './OfferCountdown';
type OfferSectionProps = {
  onBuy: () => void;
};
export function OfferSection({
  onBuy
}: OfferSectionProps) {
  return <section id="oferta" className="bg-botanic px-5 pb-10 pt-6" data-id="element-73" data-mp="idrmbl71uixa">
      <ViewerCounter data-id="element-74" data-mp="ifkpurmd8n12" />

      <div className="mt-10 flex flex-col items-center" data-id="element-75" data-mp="meae5f8xzozh">
        <img src={MAIN_MOCKUP} alt="Ebook El Secreto del Mate Perfecto con sus bonos incluidos" loading="lazy" decoding="async" width={320} height={217} className="w-full max-w-[320px] h-auto rounded-md drop-shadow-[0_20px_60px_rgba(201,168,76,0.35)]" data-id="element-76" data-mp="md0fooy6gesb" />
      </div>

      <Reveal className="mt-8" data-id="element-77" data-mp="2t6b5sds3vrjy">
        <div className="flex flex-col items-start text-left" data-id="element-78" data-mp="2t7dwaklinrzc">
          <span className="animate-badge-pulse rounded-full bg-gold px-4 py-1.5 font-sans text-[14px] font-bold text-night" data-id="element-79" data-mp="2y5fd0yvgzf7n">
            +1537 Descargas 🚀
          </span>

          <h2 className="mt-4 font-display text-[26px] leading-tight font-bold uppercase text-ivory" data-id="element-80" data-mp="xx1v3nwr020s">
            El Secreto del Mate Perfecto
          </h2>

          <div className="mt-4 flex items-baseline gap-3" data-id="element-81" data-mp="sxyviizjeo07">
            <p className="font-display text-[46px] leading-none font-bold text-gold-bright" data-id="element-82" data-mp="ox543fmvyr2k">
              $490
            </p>
            <p className="font-sans text-[17px] text-ivory/45 line-through" data-id="element-83" data-mp="1lluopdpwdxs8">
              $980
            </p>
          </div>
          <span className="animate-badge-pulse mt-4 rounded-full bg-urgent px-4 py-2 font-sans text-[13px] font-bold text-white" data-id="element-84" data-mp="1glgqene3m27e">
            50% OFF · ÚLTIMOS CUPOS 🔥
          </span>
        </div>
      </Reveal>

      <div className="mt-8" data-id="element-85" data-mp="169hcwxaem26">
        <CtaButton onClick={onBuy} data-id="element-86" data-mp="17kisq39fhq4">🛒 AGREGAR AL CARRITO</CtaButton>

        <div className="mt-4" data-id="element-87" data-mp="3sd3uht59ngzm">
          <OfferCountdown data-id="element-88" data-mp="3sbsodmoclx5c" />
        </div>

        <ul className="mt-3.5 flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5" data-id="element-89" data-mp="3sewzz5457v61">
          {['📄 100% PDF', '🔒 Pago seguro', '⚡ Acceso inmediato'].map(item => <li key={item} className="font-sans text-[13px] text-ivory/60" data-id="element-90" data-mp="2mdje1wgtm0h">
              {item}
            </li>)}
        </ul>

        <div className="mt-3" data-id="element-91" data-mp="3kve1rrmbvvcv">
          <GuaranteeSection data-id="element-92" data-mp="3oumvwxla5v8y" />
        </div>
      </div>
    </section>;
}